import script from "./CheckBoxWithLabel.vue?vue&type=script&setup=true&lang=ts"
export * from "./CheckBoxWithLabel.vue?vue&type=script&setup=true&lang=ts"

import "./CheckBoxWithLabel.vue?vue&type=style&index=0&id=e918ea10&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e918ea10"]])

export default __exports__